import CardLeague from './CardLeague'

export default CardLeague
